import { openDefectInDialog, emitDefectFlyTo } from './defectActions.js';
import { resolveModuleCoveringIrImages } from '@/features/defect-drawer/utils/resolveModuleCoveringIrImages';
import { resolveModuleListPencilAction } from '@/features/defect-drawer/utils/resolveModuleListPencilAction';
import { syncDashboardSelectedThermalImage } from './resolveThermalImageForDefectDialog.js';

export const DASHBOARD_DEFECT_TOGGLE_EVENT = 'toggle-defect-drawer';
export const DASHBOARD_DEFECT_FLY_TO_EVENT = 'defect-fly-to-coordinate';
export const DASHBOARD_DEFECT_VIEW_MODE_EVENT = 'dashboard-defect-view-mode';
/**
 * 대시보드 결함 drawer·이벤트 버스 연동 (한 번 install → teardown으로 제거)
 *
 * @param {object} vm — DashboardPage
 * @param {object} [options]
 * @param {import('vuex').Store} [options.store]
 * @returns {() => void}
 */
export function installDashboardDefectFeature(vm, options = {}) {
  const store = options.store ?? vm.$store;
  const eventBus = vm.$eventBus;

  const onToggleDrawer = () => {
    vm.showDefectDrawer = !vm.showDefectDrawer;
  };

  const onViewMode = ({ mode }) => {
    if (mode === 'module') {
      vm.showDefectDrawer = true;
    } else {
      vm.showDefectDrawer = false;
    }
  };

  eventBus.$on(DASHBOARD_DEFECT_TOGGLE_EVENT, onToggleDrawer);
  eventBus.$on(DASHBOARD_DEFECT_VIEW_MODE_EVENT, onViewMode);

  return () => {
    eventBus.$off(DASHBOARD_DEFECT_TOGGLE_EVENT, onToggleDrawer);
    eventBus.$off(DASHBOARD_DEFECT_VIEW_MODE_EVENT, onViewMode);
  };
}

/** drawer 행 클릭 → 수정 모달 (모듈 모드: 좌우 네비 = 같은 모듈 결함) */
export async function handleDashboardDefectSelect(vm, defect, options = {}) {
  const store = options.store ?? vm.$store;
  return openDefectInDialog(store, defect, {
    navigationMode: 'module',
    allModuleDefects: vm.dashboardDefects
  });
}

/** drawer 빈 모듈 연필 → 커버 IR 새 결함 등록 */
export async function handleDashboardCreateOnModule(vm, row, options = {}) {
  const store = options.store ?? vm.$store;
  const eventBus = options.eventBus ?? vm.$eventBus;
  const moduleSeq = row?.seq;
  const rings = store.state.dashboard?.moduleRingsBySeq || {};
  const moduleRing = moduleSeq == null || moduleSeq === '' ? null : rings[String(moduleSeq)];
  const images = store.getters['dashboard/getThermalImages'] || [];
  const { primary, primaryIndex, covering } = resolveModuleCoveringIrImages(moduleRing, images);

  if (!primary) {
    eventBus?.$emit('alert-on', {
      on: true,
      message: vm.$t('defects.noCoveringIrImage'),
      status: 'warning'
    });
    return;
  }

  await store.dispatch('defect/openImageForNewDefect', {
    thermalImage: primary,
    imageNavList: covering,
    imageNavIndex: primaryIndex >= 0 ? primaryIndex : 0,
    navigationMode: 'covering',
    coveringModuleSeq: moduleSeq
  });
  syncDashboardSelectedThermalImage(store, primary);
}

/**
 * 지도 더블클릭 / 리스트 Enter — 모듈 연필과 동일
 * 결함 있으면 첫 결함 수정, 없으면 커버 IR 신규 등록
 */
export async function handleDashboardModulePencil(vm, moduleSeq, options = {}) {
  if (moduleSeq == null || moduleSeq === '') {
    return;
  }
  const store = options.store ?? vm.$store;
  const all = vm.dashboardDefects || store?.state?.dashboard?.wfsDefectRows || [];
  const moduleDefects = all.filter(
    d => d?.solarModuleSeq != null && String(d.solarModuleSeq) === String(moduleSeq)
  );
  const action = resolveModuleListPencilAction({
    kind: 'panel',
    seq: moduleSeq,
    defects: moduleDefects
  });
  if (action?.type === 'edit') {
    return handleDashboardDefectSelect(vm, action.defect, options);
  }
  return handleDashboardCreateOnModule(vm, { kind: 'panel', seq: moduleSeq }, options);
}

/** drawer 지도 이동 버튼 */
export function handleDashboardDefectFlyTo(vm, defect) {
  emitDefectFlyTo(vm.$store, defect);
}
